import { graphql } from 'gatsby'
import React from 'react'
import ArticleInfo from '../../components/article/articleAside/components/ArticleInfo'

const ArticleSideInfoSection = ({ context, slice }) => {
  return <ArticleInfo context={context} data={slice.primary} />
}

export default ArticleSideInfoSection

export const query = graphql`
  fragment ArticlePageDataBody2ArticleSideInfoSection on PrismicArticlePageDataBody2ArticleSideInfoSection {
    id
    primary {
      author_section_title1 {
        text
      }
      share_section_title1 {
        text
      }
      tags_section_title1 {
        text
      }
    }
    slice_type
  }
`
